import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { loadClassroomBySlug } from '@app/classrooms/_store/classroom';
import { getClassroomState } from '@app/classrooms/_store/classroom/classroom.selectors';
import { Store } from '@ngrx/store';
import { Classroom } from 'lingo2-models';
import { Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';

@Injectable()
export class ClassroomResolver {
  constructor(private store: Store, private router: Router) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Classroom> {
    const slug = route.paramMap.get('slug');

    this.store.dispatch(loadClassroomBySlug({ slug }));

    return this.store.select(getClassroomState).pipe(
      filter((classroomState) => classroomState.loaded),
      take(1),
      map((classroomState) => classroomState.entity),
    );
  }
}
